import {Button, Flex, Typography} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import {useCSContext} from 'Context/ContentStackContext';
import DialogWrapper from './DialogWrapper';
import styles from './styles';
import {GIFTING} from '../../giftingConstants';

const GiftDialogError = ({openErrorDialog, setOpenErrorDialog, errorMessage}) => {
  const {artifacts} = useCSContext();

  return (
    <DialogWrapper closeDialogMethod={setOpenErrorDialog} open={openErrorDialog}>
      <Flex vertical gap={16} style={styles.container}>
        <img src={artifacts.gift_icon} alt="" style={{fontSize: 70, alignSelf: 'center'}} />
        <Typography.Title level={3} style={{margin: 0}}>
          {GIFTING.gifting_dialog_error.heading}
        </Typography.Title>
        <Typography.Text style={{textAlign: 'center'}}>
          {GIFTING.gifting_dialog_error.error_map[errorMessage]}
        </Typography.Text>
      </Flex>
      <div style={styles.buttonBox}>
        <Button type="primary" onClick={() => setOpenErrorDialog(false)} style={styles.button}>
          {GIFTING.gifting_dialog_error.button_text}
        </Button>
      </div>
    </DialogWrapper>
  );
};

GiftDialogError.propTypes = {
  openErrorDialog: PropTypes.bool,
  setOpenErrorDialog: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default GiftDialogError;
